import { CommentReactionItemController } from './comment-reaction-item.controller'

function CommentReactionItemDirective () {
  return {
    restrict: 'E',
    scope: {
      emojiCode: '<',
      users: '<',
      reactionCount: '<',
      reactionTooltip: '<',
      darkMode: '<'
    },
    templateUrl: '/core/directives/comment-reaction-item/comment-reaction-item.html?$$REVISION$$',
    controller: CommentReactionItemController
  }
}
export { CommentReactionItemDirective }
